import React from 'react';
import { useHasPermission, useUserDetails } from '../../../services/auth/auth';
import { ViewLayout } from '../../shared/cardLayouts/viewLayout';
import { DashboardShortcutCard } from '../../shared/cards/dashboardShortcutCard';
import { RecentsCard } from '../../shared/cards/recentsCard';
import { ReactComponent as BranchesIcon } from './../../../assets/icons/branch.svg';
import { ReactComponent as SystemIcon } from './../../../assets/icons/systems.svg';
import { ReactComponent as UsersIcon } from './../../../assets/icons/users.svg';
import { ReactComponent as ZipCodeIcon } from './../../../assets/icons/zipcode.svg';
import { ReactComponent as CampaignIcon } from './../../../assets/icons/campaign.svg';
import { ReactComponent as DascoIcon } from './../../../assets/logo-icon.svg';
import { ReactComponent as AfterHourReferralRuleIcon } from './../../../assets/icons/after-hours-referral-rules.svg';
import { AFTER_HOUR_REFERRAL_RULE, BRANCH, CAMPAIGN_ADHOC, SYSTEM, USER, ZIPCODE } from '../../../permissions';

import styles from './dashboard.module.css';


export const Dashboard = () => {

    const details = useUserDetails();
    
    const canReadBranch = useHasPermission([BRANCH.READ]);
    const canReadZipcode = useHasPermission([ZIPCODE.READ]);
    const canReadSystem = useHasPermission([SYSTEM.READ]);
    const canReadUser = useHasPermission([USER.READ]);
    const canReadAfterHourReferralRules = useHasPermission([AFTER_HOUR_REFERRAL_RULE.READ]);
    const canReadCampaigns = useHasPermission([CAMPAIGN_ADHOC.READ]);

    const greeting = () => {
        const hr = new Date().getHours();

        const greets = [
            [0, 4, 'Good night'], 
            [5, 11, 'Good morning'],
            [12, 16, 'Good afternoon'],
            [17, 19, 'Good evening'],
            [20, 24, 'Good night']
        ];

        const timeGreet = greets.reduce((a, b) => (hr >= b[0] && hr <= b[1]) ? b[2] : a, '');

        const firstName = details?.idTokenClaims?.given_name;

        return firstName ? `${timeGreet}, ${firstName}` : timeGreet;
    }

    const shortcuts = [];

    if (canReadBranch) {
        shortcuts.push(
            <DashboardShortcutCard
                to='locations/branches'
                icon={<BranchesIcon />}
                subtitle='View Branches'
            />
        );
    }

    if (canReadZipcode) {
        shortcuts.push(
            <DashboardShortcutCard
                to='locations/zipcodes'
                icon={<ZipCodeIcon />}
                subtitle='View Zip Codes'
            />
        );
    }

    if (canReadSystem) {
        shortcuts.push(
            <DashboardShortcutCard
                to='systemAccess'
                icon={<SystemIcon />}
                subtitle='View System Access'
            />
        );
    }

    if (canReadUser) {
        shortcuts.push(
            <DashboardShortcutCard
                to='users'
                icon={<UsersIcon />}
                subtitle='View Users'
            />
        );
    }

    if (canReadAfterHourReferralRules) {
        shortcuts.push(
            <DashboardShortcutCard
                to='afterHourReferralRules'
                icon={<AfterHourReferralRuleIcon />}
                subtitle='View Rules'
            />
        );
    }

    if (canReadCampaigns) {
        shortcuts.push(
            <DashboardShortcutCard
                to='communications/campaigns'
                icon={<CampaignIcon />}
                subtitle='View Campaigns'
            />
        );
    }

    // Slice the array to get a maximum of 4 items
    const displayedShortcuts = shortcuts.slice(0, 4);

    return (
        <section className={styles.Dashboard}>
            <h1>{greeting()}</h1>
            <h2>Here are some links to get you started.</h2>

            <DascoIcon className={styles.BackgroundIcon} />

            <ViewLayout>
                {displayedShortcuts}

                <RecentsCard />
            </ViewLayout>
        </section>
    )
}